import {PureToggleableElementRule} from "../../slate/html/Html";
import {DeserializedElementRule} from "../../slate/Transformation";

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "center": PureToggleableElementRule({
        onTag: 'center',
        offTag: 'p',
        //hotKey: {generic: 'mod+f'}
    }),
}